var path = 'src/app/patients/delete-patient.html';
var html = "<h1 class=page-header>Delete?</h1> <p> Are you sure you want to delete this patient? </p> <p> <button ng-disabled=patient.isDeleting class=\"btn btn-danger\" ng-click=remove(patient)> <i class=\"fa fa-trash-o\" ng-show=!patient.isDeleting></i> <i class=\"fa fa-spinner fa-spin\" ng-show=patient.isDeleting></i> Delete </button> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/delete-patient.html
 ** module id = 618
 ** module chunks = 0
 **/